module.exports = __webpack_public_path__ + "static/media/bg.ba6a6c7f.png";